<div class="assign-shops-dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header">
        <h3 class="dialog-title">Assigned Shops List</h3>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Version Info -->
    <div class="version-info">
        <span class="version-label">Version: {{versionNumber}}</span>
    </div>

    <!-- Search Bar -->
    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search...</mat-label>
            <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        
        <div class="show-selected-checkbox">
            <mat-checkbox [(ngModel)]="showSelectedOnly" (change)="onFilterChange()">
                Show Selected
            </mat-checkbox>
        </div>
    </div>

    <!-- Content Area - Shops List -->
    <div class="content-container">
        <div class="shops-list">
            <div class="shop-item" *ngFor="let shop of filteredShops" [class.selected]="shop.isSelected">
                <div class="shop-checkbox">
                    <mat-checkbox [(ngModel)]="shop.isSelected" (change)="onShopSelectionChange(shop)">
                    </mat-checkbox>
                </div>
                <div class="shop-details">
                    <div class="shop-code">{{shop.name}}</div>
                </div>
            </div>

            <!-- Empty state -->
            <div class="empty-state" *ngIf="filteredShops.length === 0">
                <p>No shops found matching your search.</p>
            </div>
        </div>
    </div>

    <!-- Dialog Actions -->
    <div class="dialog-actions">
        <button mat-button (click)="onClose()" [disabled]="isSaving">Close</button>
        <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving">
            <span *ngIf="!isSaving">Update Shops</span>
            <span *ngIf="isSaving">Saving...</span>
        </button>
    </div>
</div>